<ion-modal [isOpen]="isOpen" (didDismiss)="closeModal()">
  <ng-template>
    <div
      class="expired-pets-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="expired-pets-modal-title"
    >
      <div class="modal-header">
        <h2 id="expired-pets-modal-title">
          {{
            isPlural
              ? "You have " + petCount + " Pets Expired!"
              : "You have an expired pet!"
          }}
        </h2>
      </div>

      <div class="modal-content">
        <div class="expired-pets-list">
          <div class="pet-card" *ngFor="let pet of expiredPets">
            <div class="pet-info">
              <div class="pet-avatar">
                <img
                  [src]="pet.avatar || 'assets/icon/paw.svg'"
                  [alt]="pet.name + ' avatar'"
                />
              </div>
              <div class="pet-details">
                <h3>{{ pet.name }}</h3>
                <p class="expiration-date">
                  <ion-icon
                    name="time-outline"
                    color="danger"
                    aria-hidden="true"
                  ></ion-icon>
                  Expired:
                  {{
                    pet.expiresAt
                      ? (pet.expiresAt | date: "MMM d, y")
                      : "Unknown"
                  }}
                </p>
              </div>
            </div>

            <div class="pet-actions">
              <ion-button
                fill="outline"
                color="primary"
                size="small"
                (click)="viewPetProfile(pet)"
                class="view-btn"
                [attr.aria-label]="'View profile for ' + pet.name"
              >
                <ion-icon
                  slot="start"
                  name="eye-outline"
                  aria-hidden="true"
                ></ion-icon>
                View Profile
              </ion-button>

              <ion-button
                fill="solid"
                color="primary"
                size="small"
                (click)="extendPet(pet)"
                class="extend-btn"
                [attr.aria-label]="'Extend listing for ' + pet.name"
              >
                <ion-icon
                  slot="start"
                  name="refresh-outline"
                  aria-hidden="true"
                ></ion-icon>
                Extend Pet
              </ion-button>

              <ion-button
                fill="solid"
                color="primary"
                size="small"
                (click)="markOutcome(pet)"
                class="outcome-btn"
                [attr.aria-label]="'Remove ' + pet.name + ' from listings'"
              >
                <ion-icon
                  slot="start"
                  name="checkmark-outline"
                  aria-hidden="true"
                ></ion-icon>
                Remove Pet
              </ion-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>
